import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';
import { SelectMediaLinkResponseProps } from './SelectMediaLinkResponse';

export async function openMediaLinkModal(props: Omit<SelectMediaLinkResponseProps, 'onSelect'>) {
  const { SelectMediaLinkResponse } = await import('./SelectMediaLinkResponse');
  const obs$ = new Subject<string>();
  openModal(SelectMediaLinkResponse, {
    ...props,
    onSelect: text => {
      obs$.next(text);
      obs$.complete();
    },
  });
  return obs$.asObservable();
}
